import { EPaymentMethod } from "../../../../../../../dependencies/getContent/constants";
import { findFirst } from "../../../../../../../../utils/arrays";
import { getPaymentOptionTypeFromId, getUngranularPaymentType } from "../Button/logic/utils";
import CardIcon from "./assets/card.svg";
import SberPayIcon from "./assets/sberpay.svg";
import SbpIcon from "./assets/sbp.svg";
export var getPaymentIconFromType = function getPaymentIconFromType(id) {
  var granularType = getPaymentOptionTypeFromId(id);
  if (!granularType) return undefined;
  var ungranularType = getUngranularPaymentType(granularType);
  return findFirst([ungranularType === EPaymentMethod.SberPay && SberPayIcon, ungranularType === EPaymentMethod.SBP && SbpIcon, ungranularType === EPaymentMethod.Card && CardIcon]);
};
export var getIconProps = function getIconProps(option) {
  return {
    Icon: !option.iconUrl ? getPaymentIconFromType(option.id) : undefined,
    iconUrl: option.iconUrl
  };
};